import { createSelector } from 'reselect'

import isAvailableVariantUtil from 'modules/variant/utils/is-available'
import getFullSizeFromConversionProductVariantSelector from 'modules/product-variant/redux/selectors/get-correct-full-size-from-conversion'

const isFullSizeFromConversionOutOfStockSelector = ({ productVariant }) => createSelector(
  getFullSizeFromConversionProductVariantSelector({
    productVariant
  }),
  (fullSizeFromConversionProductVariant = {}) => {
    return !isAvailableVariantUtil(fullSizeFromConversionProductVariant)
  }
)

export default isFullSizeFromConversionOutOfStockSelector
